<div [ngClass]="{'hide-menu': hideMenu}">
  <div>
    <table class="fullwidth styled compact notifications">
      <tr *ngFor="let notification of adminNotifications" (click)="acknowledge(notification)"
        [ngClass]="{'acknowledged':notification.acknowledge }" class="{{notification.logItem.severity.toLowerCase()}}">
        <td>{{notification.logItem.created | date : 'yyyy-MM-dd HH:mm:ss'}}</td>
        <td>{{notification.storeName}}</td>
        <td>{{notification.logItem.message}}</td>
      </tr>
    </table>
  </div>
</div>
